import { Controller } from '@hotwired/stimulus';
import Sortable from 'sortablejs';
import { patchRequest } from '../../src/utils';

// Connects to data-controller="timetable--switch-band"
// Used in: school show, school timetables, action and targets in header, switch bands timetable, switch bands
// Purpose: Create a drag and drop interface for admins to switch bands from one timetable to another within a school
// Explanation:
// FIX: Should check why timetable controllers do not get updated through turbo stream but rather page has to be refreshed
// Refactor:
// 1. See if can not use global variables sotrables and modal

let sortables = [];
export default class extends Controller {
  static targets = ['sortable', 'form'];

  static values = {
    bandsToSwitch: Array, // A list of bands to be switch with band id and timetable id to be processed by controller
    schoolId: Number,
    sortables: Array,
  };

  connect() {
    console.log('switch band controller connected');
    this.createSortable();
  }

  disconnect() {
    this.destroySortable();
  }

  // add sortable drag and drop
  createSortable() {
    let context = this;

    const options = {
      group: 'shared',
      animation: 150,
      onEnd(event) {
        console.log('hello');
        // add things to the array on front end
        context.updateBandsToSwitch(event);
        console.log('updated', context.bandsToSwitchValue);
      },
    };

    this.sortableTargets.forEach((list) => {
      this.sortablesValue.push(Sortable.create(list, options));
    });
  }

  destroySortable() {
    sortables.forEach((sortable) => sortable.destroy());
    sortables = [];
  }


  formInputs() {
    // Use map to transform each item into an array of input elements
    return this.bandsToSwitchValue
      .map((item, index) => {
        let inputs = [];
        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `bandsToSwitch[][${key}]`;
            input.value = item[key];
            input.autocomplete = 'off';
            inputs.push(input);
          }
        }
        return inputs; // This now correctly returns the array of inputs for each item
      })
      .flat(); // Optionally flatten the array if you want a single array of all inputs
  }

  // Below - Checking which bands to switch

  // update the array of bands that will be sent to the backend
  updateBandsToSwitch({ item, to }) {
    let { bandId, originalTimetableId } = item.dataset;
    let timetableId = to.dataset.timetableId;
    // checking what type of movement happened to the sortable item
    let returnedToOriginal = originalTimetableId === timetableId;
    let switchedBetweenNewTimetables = this.bandsToSwitchValue.some((element) => element.bandId == bandId);
    // acting accordingly
    if (returnedToOriginal) {
      this.removeFromBandsToSwitch(bandId);
    } else if (switchedBetweenNewTimetables) {
      this.changeTimetableId(bandId, timetableId);
    } else {
      this.addToBandsToSwitch(bandId, timetableId);
    }
    const existingInputs = this.formTarget.querySelectorAll('input[type="hidden"]');
    console.log('existingInputs');
    existingInputs.forEach((input) => console.log(input.name));
    existingInputs.forEach((input) => {
      if (input.name !== 'authenticity_token') {
        this.formTarget.removeChild(input);
      }
    });
    this.formInputs().forEach((input) => this.formTarget.appendChild(input));
  }

  // add a new band-timetable pair to the bandsToSwitch
  addToBandsToSwitch(bandId, timetableId) {
    console.log('addToBandsToSwitch');
    let bandsToSwitch = this.bandsToSwitchValue;
    console.log('bandsToSwitch', bandsToSwitch);
    bandsToSwitch.push({ bandId, timetableId });
    this.bandsToSwitchValue = bandsToSwitch;
    console.log('this.bandsToSwitchValue', this.bandsToSwitchValue);
  }

  // remove a pair from the bandsToSwitch
  removeFromBandsToSwitch(bandId) {
    console.log('removeFromBandsToSwitch');

    let bandsToSwitch = this.bandsToSwitchValue;
    this.bandsToSwitchValue = bandsToSwitch.filter((element) => !(element.bandId == bandId));
  }

  // update a timetable ID in one of the pairs
  changeTimetableId(bandId, timetableId) {
    console.log('changeTimetableId');

    let bandsToSwitch = this.bandsToSwitchValue;
    this.bandsToSwitchValue = bandsToSwitch.map((element) =>
      element.bandId == bandId ? { bandId, timetableId } : element
    );
  }
}
